// tslint:disable
/**
 * Document number generator API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { NumberSequence } from '../models';
import { NumberSequenceCreate } from '../models';
import { NumberSequenceEdit } from '../models';
/**
 * DocumentNumberApi - axios parameter creator
 * @export
 */
export const DocumentNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {NumberSequenceCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSequence(companyId: string, body: NumberSequenceCreate, options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling createSequence.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createSequence.');
            }
            const localVarPath = `/document-number/company/{companyId}/sequences`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSequence(companyId: string, id: string, options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling deleteSequence.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteSequence.');
            }
            const localVarPath = `/document-number/company/{companyId}/sequence/{id}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} id 
         * @param {NumberSequenceEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSequence(companyId: string, id: string, body: NumberSequenceEdit, options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling editSequence.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editSequence.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editSequence.');
            }
            const localVarPath = `/document-number/company/{companyId}/sequence/{id}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} [title] 
         * @param {'all' | 'unset' | 'contract' | 'act' | 'bill' | 'learning_request' | 'final_document' | 'education_protocol' | 'enrollment_order' | 'expulsion_order'} [type] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'type' | 'title'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSequences(companyId: string, title?: string, type?: 'all' | 'unset' | 'contract' | 'act' | 'bill' | 'learning_request' | 'final_document' | 'education_protocol' | 'enrollment_order' | 'expulsion_order', offset?: number, limit?: number, sort?: 'type' | 'title', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling listSequences.');
            }
            const localVarPath = `/document-number/company/{companyId}/sequences`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextNumber(companyId: string, id: string, options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling nextNumber.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling nextNumber.');
            }
            const localVarPath = `/document-number/company/{companyId}/sequence/{id}/next`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentNumberApi - functional programming interface
 * @export
 */
export const DocumentNumberApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {NumberSequenceCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSequence(companyId: string, body: NumberSequenceCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NumberSequence> {
            const localVarAxiosArgs = DocumentNumberApiAxiosParamCreator(configuration).createSequence(companyId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSequence(companyId: string, id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = DocumentNumberApiAxiosParamCreator(configuration).deleteSequence(companyId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} id 
         * @param {NumberSequenceEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSequence(companyId: string, id: string, body: NumberSequenceEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NumberSequence> {
            const localVarAxiosArgs = DocumentNumberApiAxiosParamCreator(configuration).editSequence(companyId, id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} [title] 
         * @param {'all' | 'unset' | 'contract' | 'act' | 'bill' | 'learning_request' | 'final_document' | 'education_protocol' | 'enrollment_order' | 'expulsion_order'} [type] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'type' | 'title'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSequences(companyId: string, title?: string, type?: 'all' | 'unset' | 'contract' | 'act' | 'bill' | 'learning_request' | 'final_document' | 'education_protocol' | 'enrollment_order' | 'expulsion_order', offset?: number, limit?: number, sort?: 'type' | 'title', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NumberSequence>> {
            const localVarAxiosArgs = DocumentNumberApiAxiosParamCreator(configuration).listSequences(companyId, title, type, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextNumber(companyId: string, id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = DocumentNumberApiAxiosParamCreator(configuration).nextNumber(companyId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentNumberApi - factory interface
 * @export
 */
export const DocumentNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {NumberSequenceCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSequence(companyId: string, body: NumberSequenceCreate, options?: any) {
            return DocumentNumberApiFp(configuration).createSequence(companyId, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSequence(companyId: string, id: string, options?: any) {
            return DocumentNumberApiFp(configuration).deleteSequence(companyId, id, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} id 
         * @param {NumberSequenceEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSequence(companyId: string, id: string, body: NumberSequenceEdit, options?: any) {
            return DocumentNumberApiFp(configuration).editSequence(companyId, id, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} [title] 
         * @param {'all' | 'unset' | 'contract' | 'act' | 'bill' | 'learning_request' | 'final_document' | 'education_protocol' | 'enrollment_order' | 'expulsion_order'} [type] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'type' | 'title'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSequences(companyId: string, title?: string, type?: 'all' | 'unset' | 'contract' | 'act' | 'bill' | 'learning_request' | 'final_document' | 'education_protocol' | 'enrollment_order' | 'expulsion_order', offset?: number, limit?: number, sort?: 'type' | 'title', order?: 'ASC' | 'DESC', options?: any) {
            return DocumentNumberApiFp(configuration).listSequences(companyId, title, type, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextNumber(companyId: string, id: string, options?: any) {
            return DocumentNumberApiFp(configuration).nextNumber(companyId, id, options)(axios, basePath);
        },
    };
};

/**
 * DocumentNumberApi - object-oriented interface
 * @export
 * @class DocumentNumberApi
 * @extends {BaseAPI}
 */
export class DocumentNumberApi extends BaseAPI {
    /**
     * 
     * @param {string} companyId 
     * @param {NumberSequenceCreate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentNumberApi
     */
    public createSequence(companyId: string, body: NumberSequenceCreate, options?: any) {
        return DocumentNumberApiFp(this.configuration).createSequence(companyId, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentNumberApi
     */
    public deleteSequence(companyId: string, id: string, options?: any) {
        return DocumentNumberApiFp(this.configuration).deleteSequence(companyId, id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} id 
     * @param {NumberSequenceEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentNumberApi
     */
    public editSequence(companyId: string, id: string, body: NumberSequenceEdit, options?: any) {
        return DocumentNumberApiFp(this.configuration).editSequence(companyId, id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} [title] 
     * @param {'all' | 'unset' | 'contract' | 'act' | 'bill' | 'learning_request' | 'final_document' | 'education_protocol' | 'enrollment_order' | 'expulsion_order'} [type] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'type' | 'title'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentNumberApi
     */
    public listSequences(companyId: string, title?: string, type?: 'all' | 'unset' | 'contract' | 'act' | 'bill' | 'learning_request' | 'final_document' | 'education_protocol' | 'enrollment_order' | 'expulsion_order', offset?: number, limit?: number, sort?: 'type' | 'title', order?: 'ASC' | 'DESC', options?: any) {
        return DocumentNumberApiFp(this.configuration).listSequences(companyId, title, type, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentNumberApi
     */
    public nextNumber(companyId: string, id: string, options?: any) {
        return DocumentNumberApiFp(this.configuration).nextNumber(companyId, id, options)(this.axios, this.basePath);
    }

}
